// src/pages/User/NewRequest/ui/steps/review/ReviewStepDesktop.tsx
import React from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";

import { formatBRL } from "@utils/currency";

import { useReviewStep } from "../../hook/useReviewStep";
import { formatQty } from "../../hook/useProductsStep";

export function ReviewStepDesktop() {
  const { state, action } = useReviewStep();

  return (
    <Card>
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          <Typography>
            Quantidade total do pedido (L):{" "}
            <strong>{formatQty(state.totals.totalQuantity)}</strong>
          </Typography>

          <Typography>
            Preço total do pedido:{" "}
            <strong>{formatBRL(state.totals.totalPrice)}</strong>
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button color="error" variant="text" onClick={action.reset}>
              Cancelar
            </Button>

            <Button
              type="submit"
              variant="contained"
              disabled={!state.canSubmit}
            >
              {state.isSubmitting ? "Enviando..." : "Finalizar"}
            </Button>
          </Stack>
        </Box>

        {!state.validation.ok ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              maxWidth: 350,
              ml: "auto",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                opacity: 0.75,
                color: "primary.main",
                textAlign: "justify",
              }}
            >
              {state.validation.reason}
            </Typography>
          </Box>
        ) : null}
      </CardContent>
    </Card>
  );
}
